<div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card card-border">
            <div class="card-body" id="example_wrapper">
                <table id="example" datatable class="display">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Content</th>
                            <th *ngIf="smses">Receiver's Count</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="smses">
                        <tr *ngFor="let notification of smses, let i=index">
                                <td>{{i+1}}</td>
                                <td>{{ notification.createdAt | date: 'dd-MM-yyyy hh:mm aa' }}</td>
                                <td class="med-description-clamp">
                                    <div  class="description-data">
                                          <span [innerHTML]="notification._id.content.length > 40 
                                                    ? notification._id.content.slice(0, 40) + '...' 
                                                    : notification._id.content">
                                            </span>
                                        
                                    </div>
                                    <div> <a *ngIf="notification._id.content.length > 40" (click)="showContent(notification._id.content)" class="view-data">View more</a></div>
                                </td>
                 
                                <td>
                                    <a (click)="showUsersContactNumbers(notification)" class="btn btn-info" data-toggle="modal" data-target="#showUsersEmails">{{ notification.users?.length }}</a>
                                </td>
                                <td>{{ getStatus(notification.status) }}</td>
                                <td>
                                    <button class="btn btn-danger" (click)="deleteSms(notification.ids)" > 
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </td>
                            
                        </tr>
                        <tr *ngIf="smses.length==0">
                            <td colspan="100%">No data found!</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="showUsersEmails" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Receiver's Number</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul class="listing-area">
                    <li *ngFor="let email of currentGroupSmses">{{ email }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>